import ko from 'knockout';
import _ from 'lodash';
import $ from 'jquery';
import templateMarkup from 'raw-loader!./summarydetail-options.html';
import DataProvider from '../../../app/data-framework/data-provider';
import PermissionService from '../../../services/permission.service';
import '../../../app/bindings/ko-bindinghandler-htmlSafe';
import LoginService from "../../../services/login.service";

    function SummaryDetailOptions(params) {
        var self = this;

        self.params = params.widgetParams;
        self.widgetSignals = params.widgetSignals;
        self.id = params.id;
        self.validationMessage = ko.observable(null);

        self.kpiColumnOptions = ko.observableArray([]);
        self.detailColumnOptions = ko.observableArray([]);

        self.fixedDetailColumns = [];

        self.subscriptions = [
            self.params.observableData.subscribe(function(newValue) {
                self.fillColumnOptions($.extend(true, [], newValue.colOptionsSummary), $.extend(true, [], newValue.colOptionsDetail));
            })
        ];

        self.fillColumnOptions($.extend(true, [], self.params.observableOptions().colOptionsSummary), $.extend(true, [], self.params.observableOptions().colOptionsDetail));

        self.selectedKpiColumns = ko.observableArray([]);
        self.selectedDetailColumns = ko.observableArray(self.params.observableOptions().displayDetail ? self.params.observableOptions().displayDetail : []);

        self.multiSelectInitOptions = {
            includeSelectAllOption: true,
            numberDisplayed: 0,
            nonSelectedText: "(all)",
            maxHeight: 200
        };

        self.widgetSignals.optionsPanelOpen.add(function () {
            var options = self.params.observableOptions();

            self.selectedKpiColumns(options.displaySummary || getDefaultColumns(self.kpiColumnOptions()));
            self.selectedDetailColumns(options.displayDetail || _.map(self.detailColumnOptions(), 'name'));
        });

        self.selectedKpiColumns.subscribe(function() {
            self.validationMessage(null);
        });

        self.selectedDetailColumns.subscribe(function () {
            self.validationMessage(null);
        });

        self.dataProvider = DataProvider.getInstance();
        self.permissionService = new PermissionService(LoginService.userObject);
    }

    function getDefaultColumns(columns) {
        return _.chain(columns).filter({ isDefaultColumn: true }).sortBy(['seq']).map('name').value();
    }

    function isValid(item, rules) {
        return !rules.required || !_.isEmpty(item);
    }

    function removeSelectAll(options) {
        var multiselectIndex = options.indexOf('multiselect-all');

        if (multiselectIndex >= 0) {
            options.splice(multiselectIndex, 1);
        }
        return options;
    }

    SummaryDetailOptions.prototype = {
        saveOption: function() {
            var self = this;
            var options = self.params.observableOptions();

            var selectedKpiColumns = self.selectedKpiColumns();
            var selectedDetailColumns = self.selectedDetailColumns();

            selectedKpiColumns = removeSelectAll(selectedKpiColumns);
            selectedDetailColumns = removeSelectAll(selectedDetailColumns);

            selectedDetailColumns = _.union(self.fixedDetailColumns, selectedDetailColumns);

            var validKpi = isValid(selectedKpiColumns, { required: self.kpiColumnOptions().length });
            var validDetail = isValid(selectedDetailColumns, { required: self.detailColumnOptions().length});

            if (!validDetail || !validKpi) {
                var message = "Please select at least 1 column";
                if (!validKpi) {
                    message += ' and KPI';
                }
                return self.validationMessage(message);
            }

            options.displaySummary = selectedKpiColumns;
            options.displayDetail = selectedDetailColumns;

            self.params.observableOptions(options);
            self.widgetSignals.optionsPanelApply.dispatch();

            $('#' + self.id).modal('hide');
        },

        cancel: function() {
            var self = this;
            self.validationMessage(null);
            self.widgetSignals.optionsPanelClose.dispatch();
        },

        fillColumnOptions: function(kpiColumnOptions, detailColumnOptions) {
            var self = this;

            if (detailColumnOptions) {
                var filteredColumnOptions = [];

                detailColumnOptions.forEach(function(col) {
                    if (col.childDataset && $.inArray(self.fixedDetailColumns, col.name) < 0) {
                        self.fixedDetailColumns.push(col.name);
                    }

                    // todo this filters out all id columns which seems wrong
                    if (col.name !== "innerGridData" && !col.hideFromSelectList && !col.idCol && !col.childDataset) {
                        filteredColumnOptions.push(col);
                    }
                });
                self.detailColumnOptions(_.sortBy(filteredColumnOptions, ['seq']));
            }
            if (kpiColumnOptions) {
                self.kpiColumnOptions(kpiColumnOptions);
            }
        },

        // This runs when the component is torn down. Put here any logic necessary to clean up,
        // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
        dispose: function() {
            var self = this;
            self.subscriptions.forEach(function(sub) {
                sub.dispose();
            });
        }
    };


    export default { viewModel: SummaryDetailOptions, template: templateMarkup };
